'use strict';

let save, load;

if ( top.gSTB && top.gSTB.LoadUserData ) {
    // gSTB function works fine without regular binding to 'this'
    save = top.gSTB.SaveUserData;
    load = top.gSTB.LoadUserData;
} else {
    save = ( key, item ) => {
        localStorage.setItem(key, item);
    };

    load = ( key ) => {
        return localStorage.getItem(key);
    };
}

module.exports = {
    save,
    load
};
